// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import translate from "@insite/client-framework/Translate";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridWidths } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import React, { FC } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { attributesProps } from "@store/Themes/common/props/attributes";
import useExpandProps from "@store/Framework/Common/Hooks/useExpandProps";

type PartNumber = string | JSX.Element;
const hasValue = (value?: PartNumber) => {
    return value && (typeof value === "string" || (value as JSX.Element).props?.children);
};
/* Starter Custom Code - End */

interface OwnProps {
    productNumber: PartNumber; // Starter Custom Code
    customerProductNumber?: PartNumber; // Starter Custom Code
    manufacturerItem?: PartNumber; // Starter Custom Code
    showCustomerName?: boolean;
    showLabel?: boolean;
    showManufacturerItem?: boolean;
    extendedStyles?: ProductPartNumbersStyles;
    showProductNumber?: boolean;
    // Starter Custom Code
    overridedStyles?: ProductPartNumbersStyles;
}

type Props = OwnProps;

export interface ProductPartNumbersStyles {
    condensed?: boolean;
    container?: GridContainerProps;
    erpNumberGridItem?: GridItemProps;
    erpNumberLabelText?: TypographyPresentationProps;
    erpNumberValueText?: TypographyPresentationProps;
    customerNameGridItem?: GridItemProps;
    customerNameLabelText?: TypographyPresentationProps;
    customerNameValueText?: TypographyPresentationProps;
    manufacturerItemGridItem?: GridItemProps;
    manufacturerItemLabelText?: TypographyPresentationProps;
    manufacturerItemValueText?: TypographyPresentationProps;
    // Starter Custom Code
    wrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
}

export const productPartNumbersStyles: ProductPartNumbersStyles = {
    erpNumberGridItem: attributesProps.item,
    erpNumberLabelText: attributesProps.label,
    erpNumberValueText: attributesProps.value,
    customerNameGridItem: attributesProps.item,
    customerNameLabelText: attributesProps.label,
    customerNameValueText: attributesProps.value,
    manufacturerItemGridItem: attributesProps.item,
    manufacturerItemLabelText: attributesProps.label,
    manufacturerItemValueText: attributesProps.value,
    wrapper: attributesProps.wrapper,
    innerWrapper: attributesProps.innerWrapper,
};

const ProductPartNumbers: FC<Props> = ({
    productNumber,
    customerProductNumber,
    manufacturerItem,
    showCustomerName = true,
    showManufacturerItem = true,
    showLabel = true,
    extendedStyles,
    showProductNumber = true,
    // Starter Custom Code
    overridedStyles,
}) => {
    const styles = useExpandProps(productPartNumbersStyles, extendedStyles, overridedStyles); // Starter Custom Code
    const displayManufacturerNumber = showManufacturerItem && hasValue(manufacturerItem); // Starter Custom Code
    const displayCustomerNumber = showCustomerName && hasValue(customerProductNumber); // Starter Custom Code
    // Starter Removed - numberOfItems
    // Starter Removed - mobileGridItemWidth
    // Starter Removed - desktopGridItemWidth
    // Starter Removed - gridItemWidth

    return (
        <StyledWrapper {...styles.wrapper} as="span" /* Starter Custom Code */>
            {showProductNumber && (
                <StyledWrapper {...styles.innerWrapper} as="span" /* Starter Custom Code */>
                    {showLabel && (
                        <Typography {...styles.erpNumberLabelText}>
                            {translate("{0}:", translate("Part #")) /* Starter Custom Code */}
                        </Typography>
                    )}
                    {!showLabel && (
                        <VisuallyHidden>
                            <Typography {...styles.erpNumberLabelText}>
                                {translate("{0}:", translate("Part #")) /* Starter Custom Code */}
                            </Typography>
                        </VisuallyHidden>
                    )}
                    <Typography {...styles.erpNumberValueText} data-test-selector="productNumber">
                        {productNumber}
                    </Typography>
                </StyledWrapper>
            )}
            {displayCustomerNumber && (
                <StyledWrapper {...styles.innerWrapper} as="span" /* Starter Custom Code */>
                    {showLabel && (
                        <Typography {...styles.customerNameLabelText}>
                            {translate("{0}:", translate("My Part #")) /* Starter Custom Code */}
                        </Typography>
                    )}
                    {!showLabel && (
                        <VisuallyHidden>
                            <Typography {...styles.customerNameLabelText}>
                                {translate("{0}:", translate("My Part #")) /* Starter Custom Code */}
                            </Typography>
                        </VisuallyHidden>
                    )}
                    <Typography {...styles.customerNameValueText} data-test-selector="customerProductNumber">
                        {customerProductNumber}
                    </Typography>
                </StyledWrapper>
            )}
            {displayManufacturerNumber && (
                <StyledWrapper {...styles.innerWrapper} as="span" /* Starter Custom Code */>
                    {showLabel && (
                        <Typography {...styles.manufacturerItemLabelText}>
                            {translate("{0}:", translate("MFG #")) /* Starter Custom Code */}
                        </Typography>
                    )}
                    {!showLabel && (
                        <VisuallyHidden>
                            <Typography {...styles.manufacturerItemLabelText}>
                                {translate("{0}:", translate("MFG #")) /* Starter Custom Code */}
                            </Typography>
                        </VisuallyHidden>
                    )}
                    <Typography {...styles.manufacturerItemValueText} data-test-selector="manufacturerItem">
                        {manufacturerItem}
                    </Typography>
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

export default ProductPartNumbers;
